export const MODES = {
  ALL: 'ALL',
  AIR: 'Air',
  BILL_PAY: 'Bill Pay',
  DRAYAGE: 'Drayage',
  EXPEDITED: 'Expedited',
  FINAL_MILE: 'Final Mile',
  INTERMODAL: 'Intermodal',
  INTERNATIONAL: 'International',
  INTL_GROUND: 'INTL Ground',
  LTL: 'LTL',
  LTL_VOLUME: 'LTL Volume',
  OCEAN: 'Ocean',
  PARCEL: 'Parcel',
  TL: 'TL',
  TL_PARTIAL: 'TL Partial',
  WAREHOUSING: 'Warehousing',
} as const;

export type MODE_VALUES = typeof MODES[keyof typeof MODES];
